// import { GET_ALL_TRAINING_TYPE } from '@/Graphql/queries';
import CardWrapper from '@/components/common/CardWrapper/CardWrapper';
import { stepOneSchema, stepTwoSchema } from '@/components/common/UpdateProfile/Schemas';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
// import { Skeleton } from '@/components/ui/skeleton';
import { CustomTextarea } from '@/components/ui/textarea';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import {
  EQUIPMENT_AT_HOME,
} from '@/lib/constants';
// import { useQuery } from '@apollo/client';
import { useFormContext } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { z } from 'zod';

export type UserSchemaType = z.infer<typeof stepOneSchema> & z.infer<typeof stepTwoSchema>;

interface SignupStepTwoProps {
  loading: boolean;
  setStep?: React.Dispatch<React.SetStateAction<1 | 2>>;
  handleNavigateLogin?: () => void;
}

const SignupStepTwo: React.FC<SignupStepTwoProps> = ({ loading, setStep, handleNavigateLogin }) => {
  const [, setSearchParams] = useSearchParams();
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<UserSchemaType>();

  // const { data: preferredWorkouts, loading: workoutLoading } = useQuery(GET_ALL_TRAINING_TYPE);

  return (
    <div className='flex flex-col gap-5 pb-10 pt-14 lg:pt-5'>
      {/* <CardWrapper>
        <div className='space-y-4'>
          <Label>
            Primary Fitness Goals<span className='text-red'>*</span>
          </Label>
          <ToggleGroup
            type='single'
            className='grid grid-cols-3 gap-2'
            value={watch('fitnessGoals')}
            onValueChange={(val) => setValue('fitnessGoals', val, { shouldValidate: true })}
          >
            {PRIMARY_GOAL.map((goal) => (
              <ToggleGroupItem key={goal} value={goal}>
                {goal}
              </ToggleGroupItem>
            ))}
          </ToggleGroup>
          {errors?.fitnessGoals?.message && (
            <p
              aria-label='error'
              aria-errormessage={errors.fitnessGoals?.message}
              className='text-red text-xs'
            >
              {errors?.fitnessGoals?.message}
            </p>
          )}
        </div>
      </CardWrapper> */}
      {/* <CardWrapper>
        <div className='space-y-4'>
          <Label>
            Preferred Types of Workouts
            <p className='text-textSecondary font-normal mt-1'>
              (You can select multiple items)<span className='text-red'>*</span>
            </p>
          </Label>
          <ToggleGroup
            value={watch('typeOfWorkouts')}
            onValueChange={(val) => setValue('typeOfWorkouts', val, { shouldValidate: true })}
            type='multiple'
            className='grid grid-cols-3 gap-2'
          >
            {workoutLoading
              ? Array(10)
                  .fill(0)
                  .map((_, index) => <Skeleton key={index} className='w-full h-10 bg-[#343840]' />)
              : preferredWorkouts?.getAllTrainingType?.map((type) => (
                  <ToggleGroupItem key={type?._id} value={type?._id || ''}>
                    {type?.title}
                  </ToggleGroupItem>
                ))}
          </ToggleGroup>
          {errors?.typeOfWorkouts?.message && (
            <p
              aria-label='error'
              aria-errormessage={errors.typeOfWorkouts?.message}
              className='text-red text-xs'
            >
              {errors?.typeOfWorkouts?.message}
            </p>
          )}
        </div>
      </CardWrapper> */}
      <CardWrapper>
        <div className='space-y-4'>
          <Label>
            Do you have any equipment at home?
            <p className='text-textSecondary font-normal mt-1'>(You can select multiple items)</p>
          </Label>
          <ToggleGroup
            value={watch('equipments')}
            onValueChange={(val) => {
              if (
                val.includes(EQUIPMENT_AT_HOME[0]) &&
                watch('equipments')?.includes(EQUIPMENT_AT_HOME[0])
              ) {
                setValue(
                  'equipments',
                  val.filter((item) => item !== EQUIPMENT_AT_HOME[0]),
                  { shouldValidate: true },
                );
              } else if (
                val.includes(EQUIPMENT_AT_HOME[0]) &&
                !watch('equipments')?.includes(EQUIPMENT_AT_HOME[0])
              ) {
                setValue('equipments', [EQUIPMENT_AT_HOME[0]], { shouldValidate: true });
              } else if (val.length === 0) {
                setValue('equipments', [EQUIPMENT_AT_HOME[0]], { shouldValidate: true });
              } else {
                setValue('equipments', val, { shouldValidate: true });
              }
            }}
            type='multiple'
            className='grid grid-cols-3 gap-2'
          >
            {EQUIPMENT_AT_HOME.map((type) => (
              <ToggleGroupItem key={type} value={type}>
                {type}
              </ToggleGroupItem>
            ))}
          </ToggleGroup>
        </div>
      </CardWrapper>

      {/* <CardWrapper>
        <div className='space-y-4'>
          <Label>
            How often do you prefer to work out?<span className='text-red'>*</span>{' '}
          </Label>
          <ToggleGroup
            value={watch('workoutInterval')}
            onValueChange={(val) => setValue('workoutInterval', val, { shouldValidate: true })}
            type='single'
            className='grid grid-cols-3 gap-2'
          >
            {WORKOUT_FREEQUENCY.map((frequency) => (
              <ToggleGroupItem key={frequency} value={frequency}>
                {frequency.split('/')[0]}
              </ToggleGroupItem>
            ))}
          </ToggleGroup>
          {errors?.workoutInterval?.message && (
            <p
              aria-label='error'
              aria-errormessage={errors.workoutInterval?.message}
              className='text-red text-xs'
            >
              {errors?.workoutInterval?.message}
            </p>
          )}
        </div>
      </CardWrapper> */}
      <CardWrapper>
        <div className='space-y-4'>
          <Label>
            Any additional information you would like to share regarding your fitness goals or any health conditions?
          </Label>
          <span className='text-red'>*</span>
          <ToggleGroup
            type='single'
            value={`${watch('isPhysicalActivities')}`}
            onValueChange={(value) =>
              value && setValue('isPhysicalActivities', value === 'true', { shouldValidate: true })
            }
            className='grid grid-cols-2 gap-2 max-w-[200px]'
          >
            <ToggleGroupItem value='false'>No</ToggleGroupItem>
            <ToggleGroupItem value='true'>Yes</ToggleGroupItem>
          </ToggleGroup>
          <CustomTextarea
            id='physical-activites-textarea'
            //   placeholder='Please describe your injuries or medical conditions...'
            label='Describe'
            className='bg-transparent  border resize-none'
            {...register('physicalActivities')}
            error={errors?.physicalActivities?.message}
          />
          {errors?.isPhysicalActivities?.message && (
            <p
              aria-label='error'
              aria-errormessage={errors.isPhysicalActivities?.message}
              className='text-red text-xs'
            >
              {errors?.isPhysicalActivities?.message === 'Required'
                ? 'This question is required'
                : errors?.isPhysicalActivities?.message}
            </p>
          )}
        </div>
      </CardWrapper>
      {/* <CardWrapper>
        <div className='space-y-4'>
          <Label>How did you hear about us?</Label>
          <CustomTextarea
            id='physical-activites-textarea'
            //   placeholder='Please describe your injuries or medical conditions...'
            label='Heard about us'
            className='bg-transparent  border resize-none'
            {...register('contactVia')}
          />
        </div>
      </CardWrapper> */}
      {setStep && (
        <div className='flex gap-3 pt-2'>
          <Button
            id='create-account-btn'
            variant={'secondary'}
            loading={loading}
            size='lg'
            className='w-full'
            onClick={() => {
              setSearchParams({ step: '1' });
              setStep(1);
            }}
          >
            Back
          </Button>
          <Button
            id='create-account-btn'
            loading={loading}
            size='lg'
            className='w-full'
            type='submit'
          >
            Create Account
          </Button>
        </div>
      )}
      {handleNavigateLogin && (
        <h5 className='font-normal mt-2 text-center'>
          Entered the wrong number?{' '}
          <Button
            id='resend-btn'
            onClick={handleNavigateLogin}
            variant='ghost'
            className='p-0 w-min h-min'
          >
            <b>Edit Phone Number.</b>
          </Button>
        </h5>
      )}
    </div>
  );
};

export default SignupStepTwo;
